import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  generatePagePlan,
  addOpportunityToPlan,
  ignoreOpportunity,
  generateBlogFromClusterBlueprint,
  generateClusterBlueprints
} from 'src/common/Scraper';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';

export function useContentStrategyActions() {
  const queryClient = useQueryClient();
  const siteAuditDetails = useSelector(
    (state: RootState) => state?.siteAudit?.siteAuditDetails
  );
  const siteId = siteAuditDetails?._id;
  const userId = siteAuditDetails?.user_id;

  const generatePagePlanMutation = useMutation({
    mutationFn: ({
      opportunityId,
      regenerate
    }: {
      opportunityId: string;
      regenerate?: boolean;
    }) => generatePagePlan(opportunityId, siteId, regenerate),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['content-strategy', userId, siteId]
      });
    }
  });

  const addToPlanMutation = useMutation({
    mutationFn: ({ opportunityId }: { opportunityId: string }) =>
      addOpportunityToPlan(opportunityId, siteId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['content-strategy', userId, siteId]
      });
      // Todo: Content Plan - Invalidate content-plan query cache when Content Plan feature is active
      // queryClient.invalidateQueries({
      //   queryKey: ['content-plan', siteId]
      // });
    }
  });

  const ignoreOpportunityMutation = useMutation({
    mutationFn: ({ opportunityId }: { opportunityId: string }) =>
      ignoreOpportunity(opportunityId, siteId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['content-strategy', userId, siteId]
      });
    }
  });

  const generateBlogFromBlueprintMutation = useMutation({
    mutationFn: ({
      blueprintId,
      suggestion
    }: {
      blueprintId: string;
      suggestion?: string;
    }) => generateBlogFromClusterBlueprint(blueprintId, suggestion),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['content-strategy', userId, siteId]
      });
      queryClient.invalidateQueries({
        queryKey: ['blog-blueprints']
      });
    }
  });

  const generateClusterBlueprintsMutation = useMutation({
    mutationFn: ({
      clusterId,
      customEndpoint
    }: {
      clusterId: string;
      customEndpoint?: string;
    }) => generateClusterBlueprints(clusterId, siteId, customEndpoint),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['content-strategy', userId, siteId]
      });
    }
  });

  return {
    generatePagePlanMutation,
    addToPlanMutation,
    ignoreOpportunityMutation,
    generateBlogFromBlueprintMutation,
    generateClusterBlueprintsMutation
  };
}
